module.exports = __webpack_public_path__ + "media/images/emblems/Bachenbuelach-blazon-2888abd6b6fbf78127894b572a4fa498.svg";